import React, { Component } from 'react';
import TabelaPeriodos from './TabelaPeriodos';
import { Redirect } from "react-router-dom";
import { Subscribe } from 'unstated'

import UserContainer from '../../containers/user.container'
import { PracticeTestContainer } from '../../containers/practiceTest.container'

import Alert from 'react-s-alert'
import Loading from '../Loading';
import EdbButton from '../EdbButton'

class Configuracoes extends Component {

    frequencyStudentStudy = [{ value: 1, text: "Semana" }, { value: 2, text: "Quinzena" }, { value: 3, text: "Mês" }, { value: 4, text: "Bimestre" }, { value: 5, text: "Trimestre" }]

    dayOfWeek = [{ value: 1, text: "Domingo" }, { value: 2, text: "Segunda-feira" }, { value: 3, text: "Terça-feira" }, { value: 4, text: "Quarta-feira" }, { value: 5, text: "Quinta-feira" }, { value: 6, text: "Sexta-feira" }, { value: 7, text: "Sábado" }]

    periodsChanged = false
    constructor(props) {
        super(props)

        this.state = {
            saving: false,
            nuStudentQuantityError: '',
            nuAutomaticQuantityError: '',
            redirectToSimulado: false,
            loadingConfig: false
        }

        this.onClickAddPeriodo = this.onClickAddPeriodo.bind(this);
        this.onClickRemoverPeriodo = this.onClickRemoverPeriodo.bind(this);
        this.onClickSalvar = this.onClickSalvar.bind(this);

        this.onChangedtStartPeriod = this.onChangedtStartPeriod.bind(this);
        this.onChangedtEndPeriod = this.onChangedtEndPeriod.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    async componentDidMount() {
        // console.log('this.props.userContainer.state',this.props.userContainer.state);
        if(!this.props.userContainer.state.selectedSchool.idEntitySchool) {
            if(this.props.userContainer.state.schools.length === 1){
                this.props.userContainer.setState({ selectedSchool: this.props.userContainer.state.schools[0] });
                this.props.practiceTestContainer.setState({ selectedSchool: this.props.userContainer.state.schools[0] });
            }
            else {
                Alert.warning("Selecione uma escola para proceder com a configuração dos períodos");
            }
        }
        if (this.props.userContainer.state.selectedSchool.idEntitySchool) {
            this.setState({ loadingConfig: true })
            await this.props.userContainer.getConfigurations()
            await this.props.userContainer.fillPeriods()
            this.setState({ loadingConfig: false })
        }
    }

    onChangedtStartPeriod(idxPeriodo, idxPeriodob, date) {
        var periodos = this.props.userContainer.state.periods;

        //Caso tenha selecionado uma data inicial maior que a final
        if (date.getTime() > periodos[idxPeriodo].pe[idxPeriodob].dtEndPeriod.getTime()) {
            periodos[idxPeriodo].pe[idxPeriodob].dtStartPeriod = date;
            periodos[idxPeriodo].pe[idxPeriodob].dtEndPeriod = date;

            this.props.userContainer.setState({ periods: periodos });
        }
        else {
            periodos[idxPeriodo].pe[idxPeriodob].dtStartPeriod = date;

            this.props.userContainer.setState({ periods: periodos });
        }
        this.periodsChanged = true
    }

    onChangedtEndPeriod(idxPeriodo, idxPeriodob, date) {
        var periodos = this.props.userContainer.state.periods;

        //Caso tenha selecionado uma data final menor que a inicial
        if (date.getTime() < periodos[idxPeriodo].pe[idxPeriodob].dtStartPeriod.getTime()) {
            periodos[idxPeriodo].pe[idxPeriodob].dtStartPeriod = date;
            periodos[idxPeriodo].pe[idxPeriodob].dtEndPeriod = date;

            this.props.userContainer.setState({ periods: periodos });
        }
        else {
            periodos[idxPeriodo].pe[idxPeriodob].dtEndPeriod = date;

            this.props.userContainer.setState({ periods: periodos });
        }
        this.periodsChanged = true
    }

    addDaysToDate(days, date) {
        var result = (date ? new Date(date) : new Date());
        result.setDate(result.getDate() + days);
        return result;
    }

    onClickAddPeriodo(idx) {
        // console.log('idx',idx)
        var periodos = this.props.userContainer.state.periods;
        // console.log('periodos',periodos)

        if (periodos[idx].pe && periodos[idx].pe.length > 0) {
            // console.log('periodos[idx].pe')
            var nuFractions = periodos[idx].pe.length + 1;
            var periodType;
            if (nuFractions === 2) {
                periodType = 3
            } else if (nuFractions === 3) {
                periodType = 2
            } else if (nuFractions === 4) {
                periodType = 1
            }

            if (periodType) {
                var lastPeriod = periodos[idx].pe[periodos[idx].pe.length - 1];
                // console.log('lastPeriod',lastPeriod);
                periodos[idx].pe = periodos[idx].pe.map(p => {
                    p.idPeriodType = periodType
                    return p
                })
                periodos[idx].pe.push({
                    nuPeriod: lastPeriod.nuPeriod + 1,
                    dtStartPeriod: this.addDaysToDate(1, lastPeriod.dtEndPeriod),
                    dtEndPeriod: this.addDaysToDate(46, lastPeriod.dtEndPeriod),
                    hasScheduling: false,
                    idPeriodType: periodType
                });

                this.periodsChanged = true
            }
        } else {
            // console.log('!periodos[idx].pe')
            periodos[idx].pe = []
            periodos[idx].pe.push({
                nuPeriod: 1,
                hasScheduling: false,
                dtStartPeriod: new Date(),
                dtEndPeriod: this.addDaysToDate(45)
            });
            this.periodsChanged = true
        }

        this.props.userContainer.setState({ periods: periodos });
    }

    onClickRemoverPeriodo(idx, idxB) {
        var periodos = this.props.userContainer.state.periods;

        periodos[idx].pe.splice(idxB, 1);

        var nuFractions = periodos[idx].pe.length + 1
        var periodType
        if (nuFractions === 2) {
            periodType = 3
        } else if (nuFractions === 3) {
            periodType = 2
        } else if (nuFractions === 4) {
            periodType = 1
        }

        if (periodType) {
            periodos[idx].pe = periodos[idx].pe.map((p, index) => {
                p.idPeriodType = periodType
                p.nuPeriod = index + 1
                return p
            })
        }

        this.props.userContainer.setState({ periods: periodos });

        this.periodsChanged = true
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === 'nuAutomaticStudy' || name === 'nuStudentStudy') {
            this.validateQuantity(value, name === 'nuAutomaticStudy');
            this.props.userContainer.setState({
                configurations: { ...this.props.userContainer.state.configurations, [name]: value }
            });
        }
        else if (name === 'inLimitStudentStudy') {
            if(!value && !this.props.userContainer.state.configurations.nuStudentStudy) {
                this.props.userContainer.setState({
                    configurations: { ...this.props.userContainer.state.configurations, [name]: value, nuStudentStudy: 2 }
                });
            }
            else {
                this.props.userContainer.setState({
                    configurations: { ...this.props.userContainer.state.configurations, [name]: value }
                });
            }
        } else {
            this.props.userContainer.setState({
                configurations: { ...this.props.userContainer.state.configurations, [name]: value }
            });
        }

        // console.log([name] + " : " + value);
    }

    async onClickSalvar() {
        Alert.closeAll();
        const configuracoes = this.props.userContainer.state.configurations

        if(configuracoes.inLimitStudentStudy && !configuracoes.nuStudentStudy) {
            Alert.warning("Informe uma quantidade válida de estudos para o aluno");
            return;
        }
        if(!configuracoes.nuAutomaticStudy) {
            Alert.warning("Informe uma quantidade válida de estudos automáticos");
            return;
        }

        this.setState({ saving: true })

        await this.props.userContainer.saveConfigurations()

        if (this.periodsChanged)
            await this.props.userContainer.updatePeriods()

        this.setState({ saving: false })

        Alert.success('As configurações foram salvas')

        if (this.props.practiceTestContainer.state.fireRedirect) {
            this.props.practiceTestContainer.setState({ fireRedirect: false }, () => {
                this.setState({ redirectToSimulado: true })
            })
        }
    }

    validateQuantity = (num, isAutomatic) => {
        if (num !== "") {
            var n = Number(num)
            if(isAutomatic) {
                this.setState({
                    nuAutomaticQuantityError: n <= 0 ? "Quantidade de estudos tem que ser maior que zero" : ''
                });
            }
            else {
                this.setState({
                    nuStudentQuantityError: n <= 0 ? "Quantidade de estudos tem que ser maior que zero" : ''
                });
            }
        } else {
            if(isAutomatic) {
                this.setState({
                    nuAutomaticQuantityError: ''
                });
            }
            else {
                this.setState({
                    nuStudentQuantityError: ''
                });
            }
        }
    }

    render() {

        const configuracoes = this.props.userContainer.state.configurations
        const periodos = this.props.userContainer.state.periods || []

        return (
            <>
                {this.state.loadingConfig && <Loading />}

                {!this.state.loadingConfig && <div className={this.state.saving ? "edb-disabled-loading" : ""}>

                    {(!this.props.userContainer.state.selectedSchool.idEntitySchool || this.state.redirectToSimulado) && <Redirect to="/app/simulado" />}

                    <div className="edb-row edb-margin-top edb-margin-bottom">
                        <div className="edb-col s6 ">
                            <h3 className="edb-text-bold edb-margin-none edb-hide-small edb-hide-medium">Configurações</h3>
                            &nbsp;
                        </div>
                        <div className="edb-col s6 edb-right-align">
                            <EdbButton className="adap-green edb-block-mobile"
                                content="Salvar alterações"
                                loadingContent="Salvando..."
                                loading={this.state.saving}
                                onClick={this.onClickSalvar} />
                        </div>
                    </div>

                    <div className="edb-white edb-padding edb-round-large adap-text-darkergray edb-margin-large-bottom">
                        <h4 className="edb-text-bold">{this.props.userContainer.state.selectedSchool.txBrandName}</h4>
                    </div>
                    <div className="edb-white edb-padding edb-round-large adap-text-darkergray">
                        <h5 className="edb-margin-none-top edb-text-bold">Estudos</h5>

                        <label className="edb-show-inline-block">
                            <input name="inLimitStudentStudy" type="checkbox" checked={!!configuracoes.inLimitStudentStudy} onChange={this.handleInputChange} />
                            <strong>Limitar estudos adicionados pelo aluno</strong>
                        </label>

                        <div className={"edb-row-cell edb-margin-left edb-magin-top " + (configuracoes.inLimitStudentStudy ? "" : "edb-disabled")} >
                            <div className="edb-cell">
                                <small>Quantidade</small>
                                <input className="adap-input" type="number" min="1" max="999" placeholder="Ex: 2" style={{ width: "80px" }} name="nuStudentStudy" value={configuracoes.nuStudentStudy} onChange={this.handleInputChange} />
                            </div>
                            <div className="edb-cell edb-padding edb-cell-middle">
                                <br />
                                estudos por semana
                            </div>
                            {/* <div className={"edb-cell " + (configuracoes.inLimitStudentStudy ? "" : "edb-disabled")}>
                                <small>Período</small>
                                <select className="adap-input" name="inFrequencyStudentStudy" value={configuracoes.inFrequencyStudentStudy} onChange={this.handleInputChange}>
                                    {this.frequencyStudentStudy.map(f => <option key={f.value} value={f.value}>{f.text}</option>)}
                                </select>
                            </div> */}
                            {/* <div className="edb-cell edb-padding edb-cell-middle">
                                <br />
                                distribuídos em
                            </div>
                            <div className={"edb-cell " + (configuracoes.inLimitStudentStudy ? "" : "edb-disabled")}>
                                <small>Dia da semana</small>
                                <select className="adap-input" name="nuDayOfWeekStartStudentStudy" value={configuracoes.nuDayOfWeekStartStudentStudy} onChange={this.handleInputChange}>
                                    {this.dayOfWeek.map(a => <option key={a.value} value={a.value}>{a.text}</option>)}
                                </select>
                            </div> */}
                            <div className="edb-margin-left">
                                <div className='edb-text-red'>{this.state.nuStudentQuantityError}</div>
                                <small><i>
                                    Você pode limitar a quantidade de estudos que o aluno pode adicionar em sua trilha de
                                    conhecimento durante o período de uma semana.
                                </i></small>
                            </div>
                        </div>

                        <div className="edb-margin-large-top">
                            <strong>Quantidade de estudos automáticos por período:</strong>
                        </div>
                        <div className="edb-row-cell edb-margin-left edb-margin-top">
                            <div className="edb-cell edb-mobile">
                                <small>Quantidade</small>
                                <input className="adap-input" type="number" min="1" max="999" placeholder="Ex: 2" style={{ width: "80px" }} name="nuAutomaticStudy" value={configuracoes.nuAutomaticStudy} onChange={this.handleInputChange} />
                            </div>
                            <div className="edb-cell edb-padding edb-cell-middle edb-mobile">
                                <br />
                                estudos por
                            </div>
                            <div className="edb-cell edb-mobile">
                                <small>Período</small>
                                <select className="adap-input" name="inFrequencyAutomaticStudy" value={configuracoes.inFrequencyAutomaticStudy} onChange={this.handleInputChange}>
                                    {this.frequencyStudentStudy.map(f => <option key={f.value} value={f.value}>{f.text}</option>)}
                                </select>
                            </div>
                            <div className="edb-cell edb-padding edb-cell-middle edb-mobile">
                                <br />
                                distribuídos em
                            </div>
                            <div className="edb-cell edb-mobile">
                                <small>Dia da semana</small>
                                <select className="adap-input" name="nuDayOfWeekStartAutomaticStudy" value={configuracoes.nuDayOfWeekStartAutomaticStudy} onChange={this.handleInputChange}>
                                    {this.dayOfWeek.map(a => <option key={a.value} value={a.value}>{a.text}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="edb-margin-left">
                            <div className='edb-text-red'>{this.state.nuAutomaticQuantityError}</div>
                            <small><i>
                                Ajuste qual o limite de estudos por período que a
                                plataforma pode agendar para o aluno.
                            </i></small>
                        </div>

                    </div>

                    <div className="edb-white edb-padding edb-round-large adap-text-darkergray edb-margin-large-top">
                        <h5 className="edb-margin-none-top edb-text-bold">Simulados</h5>
                        <label className="edb-show-inline-block">
                            <input name="inCheckBlockWindow" type="checkbox" checked={!!configuracoes.inCheckBlockWindow} onChange={this.handleInputChange} />
                            <strong>Ao alocar um simulado, marcar sempre a opção "Habilitar o bloqueio de mudança de janela"</strong>
                        </label>

                        {/* <label className="edb-margin-small-top edb-show-inline-block">
                            <input name="inCheckContinueLater" type="checkbox" checked={!!configuracoes.inCheckContinueLater} onChange={this.handleInputChange} />
                            <strong>Ao alocar um simulado, marcar sempre a opção "Habilitar continuar depois"</strong>
                        </label> */}
                    </div>

                    <div className="edb-white edb-padding edb-round-large adap-text-darkergray edb-margin-large-top">
                        <h5 className="edb-margin-none-top edb-text-bold">Períodos</h5>

                        <div><strong>Configurar períodos letivos:</strong></div>
                        <div className="edb-margin-left">
                            <small><i>
                                Você pode definir quantos períodos de estudo sua escola divide o ano.
                            </i></small>
                        </div>

                        {typeof periodos === "object" &&
                            <TabelaPeriodos
                                className="edb-margin-top edb-margin-large-bottom"
                                periodos={periodos}
                                onChangedtStartPeriod={this.onChangedtStartPeriod}
                                onChangedtEndPeriod={this.onChangedtEndPeriod}
                                onClickRemoverPeriodo={this.onClickRemoverPeriodo}
                                onClickAddPeriodo={this.onClickAddPeriodo}
                                editable={this.props.userContainer.state.editPeriods}
                            />}
                    </div>

                    <div className="edb-row edb-margin-top edb-margin-bottom">
                        <div className="edb-col s6">
                            &nbsp;
                        </div>
                        <div className={"edb-col s6 edb-right-align " + (this.state.nuAutomaticQuantityError || this.state.nuStudentQuantityError ? 'edb-disabled' : '')} >
                            <EdbButton className="adap-green edb-block-mobile"
                                content="Salvar alterações"
                                loadingContent="Salvando..."
                                loading={this.state.saving}
                                onClick={this.onClickSalvar} />
                        </div>
                    </div>

                </div>}
            </>
        );

    }
}

export default () => (<Subscribe to={[UserContainer, PracticeTestContainer]}>
    {(user, simulado) => <Configuracoes userContainer={user} practiceTestContainer={simulado} />}
</Subscribe>);